export default "__VITE_ASSET__CR9SzbMd__"